<template>
  <div>
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="true" />
    <LoginForm
      v-if="formularioDeLogin"
      @login="realizaLogin"
      @recuperarConta="mostrarCamposRecuperarConta" />

    <RecuperarSenhaForm
      v-if="!formularioDeLogin"
      @enviarEmail="enviaEmailRecuperacaoSenha"
      @recuperarConta="mostrarCamposRecuperarConta" />
  </div>

</template>

<script>

import LoginForm from './LoginForm.vue'
import RecuperarSenhaForm from './RecuperarSenhaForm.vue'

import autenticacaoService from '../../services/autenticacao.service'
import GeradorMensagens from '@/mixins/GeradorMensagens'

export default {
  name: 'HomeFormulario',
  mixins: [GeradorMensagens],
  components: {
    LoginForm,
    RecuperarSenhaForm,
  },
  data() {
    return {
      formularioDeLogin: true,
      isLoading: false,
    }
  },
  methods: {
    realizaLogin(dados) {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$emit('loginMethod', dados)
        }
      })
    },
    enviaEmailRecuperacaoSenha(dados) {
      this.isLoading = true
      autenticacaoService.enviaEmailRecuperacaoSenha(dados)
        .then(res => {
          this.mostrarCamposRecuperarConta()
          this.tratarRespostaMsg(res)
        })
        .catch(err => {
          this.tratarRespostaMsg(err)
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    mostrarCamposRecuperarConta() {
      this.formularioDeLogin = !this.formularioDeLogin
    },
  },
}

</script>

<style lang="scss" scoped>
@import '@/scss/breakpoints.scss';
@import '@/scss/colors.scss';

.user-form {
  display: flex;
  flex-direction: column;

  padding: 2rem 1rem 1rem;
  border-radius: 0.3rem;
  box-shadow: 2px 4px 8px $cor-fundo-escura;
  background-color: $cor-fundo-clara;

  @media (min-width: $medium-size) {
    margin: 1em;
    width: 275px;
  }

  @media (min-width: $large-size) {
    width: 375px;
  }
}

.button-full-width {
  margin: 0.5rem 0;
  height: 3rem;
}

.btnRecuperarSenha {
  margin-top: 1rem;
}

</style>
